import React from 'react';

import { Box, Stack, Typography } from '@mui/material';

import {
  FormRadioButtonGroup,
  FormTextField
} from '@/components/NewUI/Components/CustomUIElements';

import { styles } from './styles';

import type { PhoneChoice as PhoneChoiceValue } from './types';

interface IProps {
  // Masked by the server.
  maskedPhoneOnFile: string;
  choice: PhoneChoiceValue;
  onChoiceChange: (choice: PhoneChoiceValue) => void;
  phone: string;
  onPhoneChange: (phone: string) => void;
  onPhoneBlur: () => void;
  error: string | null;
}

// "Call me on … / Call a different number". The one-off number never replaces
// the one on the application.
const PhoneChoice = ({
  maskedPhoneOnFile,
  choice,
  onChoiceChange,
  phone,
  onPhoneChange,
  onPhoneBlur,
  error
}: IProps) => (
  <Stack aria-labelledby="booking-phone-heading" component="section" sx={styles.card}>
    <Typography component="h2" id="booking-phone-heading" sx={styles.cardHeading}>
      Where should Rosie call you?
    </Typography>
    <Box sx={styles.radioGroup}>
      <FormRadioButtonGroup
        defaultValue={choice}
        onChange={(value) => onChoiceChange(value as PhoneChoiceValue)}
        options={[
          {
            value: 'on_file',
            label: (
              <>
                {'Call me on '}
                <strong>{maskedPhoneOnFile}</strong>
              </>
            )
          },
          { value: 'different', label: 'Call a different number' }
        ]}
      />
    </Box>
    {choice === 'different' ? (
      <Stack sx={styles.phoneField}>
        <FormTextField
          fullWidth
          required
          error={error ?? undefined}
          errorSx={styles.fieldError}
          id="booking-different-number"
          label="Phone number"
          onBlur={onPhoneBlur}
          onChange={(event) => onPhoneChange(event.target.value)}
          placeholder="0412 345 678"
          value={phone}
        />
        <Typography sx={styles.caption}>
          Only used for this interview. The number on your application stays the same.
        </Typography>
      </Stack>
    ) : null}
  </Stack>
);

export default PhoneChoice;
